// authActions.js
import axios from "../api/axiosConfig"; // Uses your configured interceptor
import { createAsyncThunk } from "@reduxjs/toolkit";

export const registerUser = createAsyncThunk(
  "auth/register",
  async ({ firstname, lastname, email, phoneNumber, role, password }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      // The baseURL is already handled inside axiosConfig.js
      await axios.post(
        "/api/v1/auth/register",
        { firstname, lastname, email, phoneNumber, role, password },
        config
      );

      return true;
    } catch (error) {
      if (error.response && error.response.data.message) {
        throw error.response.data.message;
      } else {
        throw error.message;
      }
    }
  }
);

export const logOut = () => {
  // Clear the actual keys your app uses
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  localStorage.removeItem("userRole");
};
